<template>
  <div class="info">
    <div class="info_title">专属客户经理</div>
    <div class="info_usename">{{ serviceInfo.username }}</div>
    <div class="info_content">
      <div class="flex justify-between items-center mb-2">
        <p class="info_content_text">手机：</p>
        <el-button
          class="info_content_button"
          v-clipboard="onCopy(serviceInfo.mobile)"
          v-clipboard:success="onCopySuccess"
          v-clipboard:error="onCopyError"
          >复制</el-button
        >
      </div>
      <div class="info_content_text">{{ serviceInfo.mobile }}</div>
      <div class="flex justify-between items-center mt-4 mb-2">
        <p class="info_content_text">邮箱：</p>
        <el-button
          class="info_content_button"
          v-clipboard="onCopy(serviceInfo.email)"
          v-clipboard:success="onCopySuccess"
          v-clipboard:error="onCopyError"
          >复制</el-button
        >
      </div>
      <div class="info_content_text mb-7">{{ serviceInfo.email }}</div>
      <el-image v-if="serviceInfo.qr_code" :src="serviceInfo.qr_code" fix="cover"></el-image>
    </div>
  </div>
</template>

<script>
import clipboard from "@/directives/clipboard";
import useMessage from "~/composables/useMessage";

export default {
  directives: {
    clipboard,
  },
  props:{
    serviceInfo: Object
  },
  setup() {
    const $message = useMessage();
    const onCopy = (text) => {
      return text;
    };
    const onCopySuccess = () => {
      $message.success("复制成功");
    };
    const onCopyError = () => {
      $message.error("复制失败");
    };
    return { onCopy, onCopySuccess, onCopyError };
  },
};
</script>
<style lang="scss" scoped>
.info {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  min-height: 865px;
  width: 244px;
}
.info_title {
  border-bottom-width: 1px;
  font-weight: 500;
  height: 65px;
  font-size: 1.25rem;
  line-height: 1.75rem;
  line-height: 65px;
  padding-left: 20px;
  --tw-text-opacity: 1;
  color: rgba(31, 33, 41, var(--tw-text-opacity));
  width: 100%;
}
.info_usename {
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.75rem;
  margin-top: 23px;
  margin-left: 24px;
  margin-bottom: 18px;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.info_content {
  padding-left: 24px;
  padding-right: 24px;
}
.info_content_text {
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgba(31, 33, 41, var(--tw-text-opacity));
  vertical-align: middle;
}
.info_content_button {
  --tw-border-opacity: 1;
  border-color: rgba(0, 94, 220, var(--tw-border-opacity));
  height: 24px;
  padding-left: 9px;
  padding-right: 9px;
  padding-top: 2px;
  padding-bottom: 2px;
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
  width: 46px;
}
</style>
